// 初期表示
export const PAGE_INIT = "corp/overseas/shares/shareholder/PAGE_INIT";
